import classNames from 'classnames';
import * as React from 'react';

import { ESpoilerCategoryRequest, ISuburbanOfferHistorySpoilerFilters } from '../../../../store/offerHistory';
import * as styles from './CategoryTabs.css';

interface ICategoryTabsProps extends Omit<ISuburbanOfferHistorySpoilerFilters, 'activeCategory'> {
  activeCategory: ESpoilerCategoryRequest | undefined;
  onTabClick: (category: ESpoilerCategoryRequest) => void;
}

export const CategoryTabs: React.FC<ICategoryTabsProps> = ({ activeCategory, categories, onTabClick }) => {
  return (
    <ul className={styles['category-tabs']} data-testid="offers_history_categories">
      {categories.map(({ label, value }) => (
        <li
          onClick={() => onTabClick(value)}
          key={value}
          className={classNames(styles['tab'], activeCategory === value && styles['active'])}
        >
          {label}
        </li>
      ))}
    </ul>
  );
};
